import { render, staticRenderFns } from "./deliveryorderlist-bottom.vue?vue&type=template&id=206d01fa&scoped=true&"
import script from "./deliveryorderlist-bottom.vue?vue&type=script&lang=js&"
export * from "./deliveryorderlist-bottom.vue?vue&type=script&lang=js&"
import style0 from "./deliveryorderlist-bottom.vue?vue&type=style&index=0&id=206d01fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206d01fa",
  null
  
)

export default component.exports